export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  SYSTEM_ADMIN: 'system_admin',
  SALES: 'sales',
  USER: 'user'
} as const

export type Role = typeof ROLES[keyof typeof ROLES]

export const ROLE_LABELS: Record<string, string> = {
  [ROLES.SUPER_ADMIN]: '超级管理员',
  [ROLES.ADMIN]: '管理员',
  [ROLES.SYSTEM_ADMIN]: '系统管理员',
  [ROLES.SALES]: '销售人员',
  [ROLES.USER]: '普通用户'
}

export const isAdmin = (role: string | undefined | null): boolean => {
  return role === ROLES.SUPER_ADMIN || role === ROLES.ADMIN
}

export const isSuperAdmin = (role: string | undefined | null): boolean => {
  return role === ROLES.SUPER_ADMIN
}

export const isSystemAdmin = (role: string | undefined | null): boolean => {
  return role === ROLES.SYSTEM_ADMIN
}

export const canViewAllCustomers = (role: string | undefined | null): boolean => {
  return isAdmin(role)
}

export const canAccessImportMenu = (role: string | undefined | null): boolean => {
  return isAdmin(role) || role === ROLES.SYSTEM_ADMIN
}

export const getRoleLabel = (role: string): string => {
  return ROLE_LABELS[role] || role
}

export const filterDataByCustomerPermission = <T extends Record<string, unknown>>(
  data: T[],
  permittedCustomerIds: number[]
): T[] => {
  if (!permittedCustomerIds || permittedCustomerIds.length === 0) {
    return data
  }

  const idSet = new Set(permittedCustomerIds)
  return data.filter(item => {
    const cid = (item as Record<string, unknown>).customer_id
      || (item as Record<string, unknown>).customerId
      || ((item as Record<string, unknown>).customer as { id: number } | undefined)?.id
    return idSet.has(Number(cid))
  })
}

export const hasCustomerPermission = (
  customerId: number,
  permittedCustomerIds: number[]
): boolean => {
  if (!permittedCustomerIds || permittedCustomerIds.length === 0) {
    return true
  }
  return permittedCustomerIds.includes(Number(customerId))
}
